<mf-row>
  <mf-field-radio-boolean
    [label]="gridFilter.header"
    [(ngModel)]="value" />
</mf-row>
